import React, { useRef } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import {RiCodeSSlashLine} from "react-icons/ri";
import {MdDesignServices} from "react-icons/md";

import './Deailing.css';

const Dealing = () => {
    const ref = useRef(null);
    React.useEffect(() => {
      import("@lottiefiles/lottie-player");
    });
  return (
    <div className='dealing'>
        <Container>
            <Row>
           
            <Col  xs={12} md={4} >
                <div className="dealing-info">
                   <MdDesignServices className='deailng-icons'/>
                    <h2>Dealing with designer</h2>
                    <p>I receive design from ui designer and dealing with it in many ways i can deal with xd files or figma files but what i prefer is dealing with zipline</p>
                </div>
            </Col>
                <Col  xs={12} md={4} className="center-side">
                      <lottie-player
              id="firstLottie"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src="https://assets1.lottiefiles.com/packages/lf20_rkyfvrzn.json"
            ></lottie-player></Col>
               
                 <Col  xs={12} md={4} >
                  <div className="dealing-info">
                    <RiCodeSSlashLine className='deailng-icons'/>                    <h2>Dealing with backend</h2>
                    <p>I make my components usable to use it in many diffrent places with diffrent data that i receive from api</p>
                  </div>
                </Col>
                  
                  
            </Row>
        </Container>
    </div>
  )
}

export default Dealing